module.exports = __webpack_public_path__ + "img/CTWP__Staff_04.e866dbea.png";